<!-- https://beholdr.github.io/maska/v3 -->
<template>
  <v-text-field
    v-bind="$attrs"
    :label="label"
    v-model="modelValue"
    :placeholder="placeholder ?? mask"
    variant="outlined"
    density="compact"
    color="warning"
    ref="input"
    :autofocus="autofocus"
    persistent-hint
    :required="required"
    :error-messages="errorText"
    v-maskito="maskOptions"
  >
    <template v-slot:append-inner v-if="appendInnerIcon">
      <v-btn
        variant="text"
        color="primary"
        :icon="appendInnerIcon"
        @click="emit('appendClick')"
      />
    </template>
  </v-text-field>
</template>

<script setup>
import { useTemplateRef, onMounted, reactive, ref } from "vue";
//import { vMaska } from "maska/vue";
import { maskito } from "@maskito/vue";
import { maskitoNumberOptionsGenerator } from "@maskito/kit";

const txtValue = ref("");

const emit = defineEmits(["appendClick"]);
const props = defineProps({
  mask: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: false,
  },
  placeholder: {
    type: String,
    required: false,
  },
  appendInnerIcon: {
    type: String,
    required: false,
  },
  autofocus: {
    type: Boolean,
    required: false,
  },
  required: {
    type: Boolean,
    required: false,
  },
  errorText: {
    type: String,
    required: false,
  },
});

console.log("props", props);

const maskOptions = {
  // Define your mask options here if needed
  // For example, you can set a default decimal separator or thousands separator
  mask: props.mask.split("").map((char) => {
    if (char === "#") return /\d/; // digit
    if (char === "@") return /[a-zA-Z]/; // letter
    if (char === "*") return /[a-zA-Z0-9]/; // alphanumeric
    if (char === "X") return /[0-9a-zA-Z]/; // alphanumeric
    if (char === "S") return /[a-zA-Z]/; // letter
    if (char === "A") return /[a-zA-Z]/; // uppercase letter
    if (char === "a") return /[a-zA-Z]/; // lowercase letter
    if (char === "D") return /[0-3]/; // digit 0-3
    if (char === "H") return /[0,1,2]/; // digit 0-2
    if (char === "M") return /[0,1]/; // digit 0-1
    if (char === "5") return /[0-5]/; // digit 0-5
    if (char === "1") return /\d/; // digit 0-9

    return char; // other characters are treated as literals
  }),
  overwriteMode: "replace",
};

const inputRef = useTemplateRef("input");

onMounted(() => {
  if (props.autofocus) {
    setTimeout(() => {
      // ugly hack to focus the input after the DOM is updated
      if (inputRef.value && typeof inputRef.value.focus === "function") {
        inputRef.value.focus();
      } else if (inputRef.value && inputRef.value.$el) {
        const el = inputRef.value.$el.querySelector("input");
        if (el) el.focus();
      }
    }, 300);
  }
});

const modelValue = defineModel();

// Expose a focus method so parent components can programmatically focus
const focus = () => {
  if (inputRef.value && typeof inputRef.value.focus === "function") {
    inputRef.value.focus();
  } else if (inputRef.value && inputRef.value.$el) {
    const el = inputRef.value.$el.querySelector("input");
    if (el) el.focus();
  }
};

// Setzt den Cursor an den Anfang des Inputs
const setCursorToStart = () => {
  if (inputRef.value && inputRef.value.$el) {
    const el = inputRef.value.$el.querySelector("input");
    if (el && typeof el.setSelectionRange === "function") {
      el.focus();
      el.setSelectionRange(0, 0);
    }
  }
};

defineExpose({ focus, setCursorToStart });

// const maskDefinitions = {
//   "#": { pattern: /\d/ },
// X: { pattern: /[0-9a-zA-Z]/ },
// S: { pattern: /[a-zA-Z]/ },
// A: { pattern: /[a-zA-Z]/, transform: (v) => v.toLocaleUpperCase() },
// a: { pattern: /[a-zA-Z]/, transform: (v) => v.toLocaleLowerCase() },
// "!": { escape: true },
// D: { pattern: /[0-3]/, transform: (char) => char.toUpperCase() },
// H: { pattern: /[0,1,2]/, transform: (char) => char.toUpperCase() },
// M: { pattern: /[0,1]/, transform: (char) => char.toUpperCase() },
// 5: { pattern: /[0-5]/, transform: (char) => char.toUpperCase() },
// 1: { pattern: /[0-9]/, transform: (char) => char.toUpperCase() },
// };
</script>
<style>
.v-field__field {
  flex: 1 0;
  grid-area: field;
  position: relative;
  align-items: flex-start;
  display: flex;
  min-width: 150px;
}
</style>
